import { NuvoThrobber, NuvoThrobberProps } from '@nuvolo/nuux-core/components/NuvoThrobber';
import styled from 'styled-components';

const LoaderDiv = styled.div`
  .loader div {
    background: transparent;
  }
`;

export default function StandardThrobber(props: NuvoThrobberProps) {
  return (
    <LoaderDiv>
      <div className="loader">
        <NuvoThrobber mode="medium" size={40} {...props} />
      </div>
    </LoaderDiv>
  );
}
